import { Box, Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { SETTINGS_SECTION_ROW_PADDING } from 'src/components/SettingsSection/SettingsSectionRow';
import { SettingsSectionEmptyRowProps } from './settings-section-empty-row.types';

/**
 * Stands in for the rows of a SettingsSectionCard that has nothing to list yet. It shares the
 * row inset, so the message lines up with the rows that replace it.
 */
export const SettingsSectionEmptyRow = forwardRef<
  HTMLDivElement,
  SettingsSectionEmptyRowProps
>(function SettingsSectionEmptyRow({ children, action, ...rest }, ref) {
  return (
    <Stack
      ref={ref}
      direction={{ xs: 'column', sm: 'row' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      spacing={1.5}
      {...SETTINGS_SECTION_ROW_PADDING}
      {...rest}
    >
      <Typography variant="body2" fontSize="0.8125rem" color="custom.OV.sys.onSurfaceVariant">
        {children}
      </Typography>
      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Stack>
  );
});
